import { useMemo } from 'react';

import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';

import { ENABLE_BNPL_R2_FAILED_PAYMENT_RECOVERY, BNPL_R2_FAILED_PAYMENT_RECOVERY_EXPERIMENT_NAME } from '#client/constants/experimentsFlags';

export default function useBnplRecoveryContext({
  unpaidInvoices = [],
  hadSuccessPayment = null,
  currentPaid,
  errorMessage,
  accountUuid
} = {}) {
  const treatment = useExperimentFlag(ENABLE_BNPL_R2_FAILED_PAYMENT_RECOVERY, null);

  const dynamicProperties = useMemo(() => ({
    totalUnpaidInvoiceAmount: Math.round(
      unpaidInvoices.reduce((sum, inv) => sum + (Number(inv.total) || 0), 0) * 100
    ) / 100,
    totalUnpaidInvoiceCount: unpaidInvoices.length,
    currentUnpaidInvoiceApiId: unpaidInvoices[0]?.id,
    currentUnpaidInvoiceAmount: unpaidInvoices[0]
      ? Number(unpaidInvoices[0].total) || 0
      : undefined,
    unpaidInvoiceApiIds: unpaidInvoices.map((inv) => inv.id),
    hadSuccessPayment,
    experimentName: BNPL_R2_FAILED_PAYMENT_RECOVERY_EXPERIMENT_NAME,
    experimentTreatment: treatment,
    accountUuid,
    ...(currentPaid && {
      currentPaidInvoiceApiId: currentPaid.id,
      currentPaidInvoiceAmount: currentPaid.amount
    }),
    ...(errorMessage && { errorMessage })
  }), [unpaidInvoices, treatment, hadSuccessPayment, currentPaid, errorMessage, accountUuid]);

  return { dynamicProperties };
}
